import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { Route, Routes } from 'react-router-dom';

import './App.scss';

import { isAdminProfile } from './services/profile';
import { recuperaInformacoesDoUsuario, logout, erroAutenticacao, autenticacaoEmProcesso, deveRedirecionarParaAutenticacao, redirecionaParaAutenticacao, isAutenticado, verificaRolesAdmin } from './services/authentication';
import { oidcUserProfileExists, saveOidcUserProfile, loadOidcUserProfile, saveOidcAccessToken, saveOidcAccessTokenExpiresAt, clearOidcInformation } from './services/oidc';

import Header from './components/Header';
import Footer from './components/Footer';
import AdminClassificacoes from './paginas/AdminClassificacoes';
import AdminApuracoes from './paginas/AdminApuracoes';
import ContribuinteClassificacao from './paginas/ContribuinteClassificacao';
import ContribuinteResgate from './paginas/ContribuinteResgate';
import NaoEncontrada from './paginas/NaoEncontrada';
import Carregando from './components/CarregandoComponent';
import Navegacao from './components/Navegacao';
import UsuarioComponent from './components/UsuarioComponent';
import { formataCpf } from './services/cpf';
import AcessoNegado from './components/AcessoNegado';

function App() {

  const auth = useAuth();
  const erro = erroAutenticacao(auth);
  const processoDeAutenticacao = autenticacaoEmProcesso(auth);
  const [carregando, setCarregando] = useState(true);
  const [carregandoConteudo, setCarregandoConteudo] = useState(true);
  const [govBrCnpjs, setGovBrCnpjs] = useState([]);
  const [cpf, setCpf] = useState(null);
  const [nome, setNome] = useState(null);
  const [nomeCompleto, setNomeCompleto] = useState(null);
  const [username, setUsername] = useState(null);
  const [perfilAdmin, setPerfilAdmin] = useState(null);

  const respostaUsuarioHandler = useCallback(function (profile) {
    saveOidcAccessToken(auth.user?.access_token);
    saveOidcAccessTokenExpiresAt(auth.user?.expires_at);
    saveOidcUserProfile(profile);
    setProfileInfo(profile);
  }, [auth]);

  const erroUsuarioHandler = useCallback(function (error) {
    console.error(error)
    logout(auth);
  }, [auth]);

  useEffect(() => {
    simularAtraso()
  }, []);

  useEffect(function () {
    if (auth.isLoading) {
      setCarregandoConteudo(true);
    } else if (deveRedirecionarParaAutenticacao(auth)) {
      clearOidcInformation();
      redirecionaParaAutenticacao(auth);
    } else if (oidcUserProfileExists()) {
      setPerfilAdmin(verificaRolesAdmin(auth));
      saveOidcAccessToken(auth.user?.access_token);
      saveOidcAccessTokenExpiresAt(auth.user?.expires_at);
      setProfileInfo(loadOidcUserProfile());
    } else if (auth.isAuthenticated) {
      recuperaInformacoesDoUsuario(auth).then(respostaUsuarioHandler).catch(erroUsuarioHandler);
    }
  }, [auth, username, respostaUsuarioHandler, erroUsuarioHandler]);

  function setProfileInfo(profile) {
    setCpf(profile?.cpf);
    setNome(profile?.name);
    setGovBrCnpjs(profile?.cnpj);
    setUsername(profile?.username);
    setNomeCompleto(profile?.nomeCompleto)
  };

  function simularAtraso() {
    setTimeout(() => {
      setCarregando(false);
    }, 2000);
  };

  function rotaAdmin() {
    return (
      <Routes>
        <Route path='*' element={<NaoEncontrada />} />
        <Route path='/' element={<AdminClassificacoes username={username} />} />
      </Routes>
    );
  };

  function rotaUser() {
    return (
      <Routes>
        <Route path='*' element={<NaoEncontrada />} />
        <Route path='/' element={<ContribuinteClassificacao cpf={cpf} govBrCnpjs={govBrCnpjs} />} />
      </Routes>
    );
  };

  function chamarComponente() {
    if (erro) {
      return <p>Erro na autenticação: {erro}</p>
    } else if (processoDeAutenticacao) {
      return <p>{processoDeAutenticacao}</p>
    } else if (!isAutenticado) {
      return <AcessoNegado className={'fa-solid fa-circle-xmark'} titulo={"Não autenticado"} />
    } else if (!cpf && !isAdminProfile()) {
      if (carregandoConteudo) {
        return <Carregando />
      } else {
        return <AcessoNegado className={'fa-solid fa-circle-xmark'} titulo={"CPF não encontrado"} />
      }
    } else if (!isAdminProfile() && govBrCnpjs.length === 0) {
      return <AcessoNegado className={'fa-solid fa-circle-xmark'} titulo={"Não há CNPJs vinculados a este CPF"} />
    } else if (!isAdminProfile()) {
      return <>
        <UsuarioComponent nome={nome}>
          <br />
          CPF: {formataCpf(cpf)}
        </UsuarioComponent>
        {/* <Navegacao usuarioAdmin={false} /> */}
        {rotaUser()}
      </>
    } else if (perfilAdmin && isAdminProfile()) {
      return <>
        {carregando ?
          <Carregando />
          : <div>
            <UsuarioComponent nome={nomeCompleto} />
            {/* <Navegacao usuarioAdmin={true} /> */}
            {rotaAdmin()}
          </div>}
      </>
    } else if (!perfilAdmin && isAdminProfile()) {
      return <>
        {carregando ?
          <Carregando />
          : <AcessoNegado className={'fa-solid fa-lock'} titulo={"Acesso negado"} textoComplementar={"Desculpe, você não está autorizado a acessar essa página."} />}
      </>
    } else {
      return <Carregando />
    }
  };

  /*
  return (
    <React.Fragment>
      <div className="wrapper">
        <Header logout={logout.bind(null, auth)} />
        <div className="container h1-container">
          <h1 className="page-header">Compliance</h1>
        </div>
        <div className='container'>
          {chamarComponente()}
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
*/

return (
  <React.Fragment>
    <div className="wrapper">
      {
        <div style={{ textAlign: 'center' }}>
          <br />
          <br />
          <h3>
            <i style={{ opacity: '0.5', fontSize: '5rem' }} className={'fa-solid fa-person-digging'}></i>
            <br />
            <br />
            Sistema em manutenção
          </h3>
          <p>Em caso de dúvida, entre em contato com a administração do site.</p>
        </div>
      }
    </div>
  </React.Fragment>
);

}; 


export default App;

